import React, { FC, Suspense, useEffect, useState } from 'react';
import DropDownMultiSelectMFACustom from '../../../components/dropDownMultiSelectMFACustom';
import { useDispatch, useSelector } from 'react-redux';
import { error, ikaMapCountries, ikaMapCountriesLoading, ikaMapData, ikaMapDataLoading, inputSuggestions } from '../../../reducer/mappingFiles/selectors';
import { deleteItems, exportData, getFilters, loadCountries, loadData, massUpload, setError } from '../../../actions/mappingFiles/ikamapActions';
import { useParams } from 'react-router-dom';
import toast, { Toaster } from 'react-hot-toast';
import Spinner from 'react-bootstrap/esm/Spinner';
import { EditModal, IKAMapTable } from './components';
import * as constants from './constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { IIKAMap, IInputSugestion, IInputSuggestionsList, ISelectedFilters } from '../../../reducer/mappingFiles/_interfaces';
import { ICountry } from '../../../reducer/General/_interfaces';
import ChannelCategoryDialogueBox from '../../../components/channelCategoryDialogueBox';
import { ERROR_TOAST_DUSATION } from '../../../constant/constants';
import { Autocomplete, TextField } from '@mui/material';
import Papa from 'papaparse';
import { SET_IKA_MAP_DATA_LOADING } from '../../../reducer/mappingFiles/constants';


const AutocompleteSX = {
    backgroundColor: 'white',
    '& .MuiOutlinedInput-root': {
        padding: '4px',
        '& fieldset': {
            top: 0,
        }
    }
}

export const IKAMapPage:FC = () => {
    const adminIds = localStorage.getItem('access_token') ? JSON.parse(localStorage.getItem('access_token') || '').user.form_admin_list : [];
    const { id } = useParams<{id:string}>();
    const dispatch = useDispatch();
    
    const errorMessage = useSelector(error);

    const countries = useSelector(ikaMapCountries)
    const countriesLoading = useSelector(ikaMapCountriesLoading);
    
    const data:IIKAMap[] = useSelector(ikaMapData);
    const dataLoading = useSelector(ikaMapDataLoading);
    const filters:IInputSuggestionsList = useSelector(inputSuggestions);

    const [openDeleteDialogueBox, setOpenDeleteDialogueBox] = useState<boolean>(false);
    const [openAddEditDialogueBox, setOpenAddEditDialogueBox] = useState<boolean>(false);
    const [selectedItem, setSelectedItem] = useState<IIKAMap | null>(null);

    //Filters
    const [selectedFilters, setSelectedFilters] = useState<ISelectedFilters>(constants.INITIAL_FILTERS);
    
    const handleAddEditDialogueBox = () => setOpenAddEditDialogueBox(!openAddEditDialogueBox)
    const handleDeleteDialogueBox = () => {
        setOpenDeleteDialogueBox(!openDeleteDialogueBox)
        if (!openDeleteDialogueBox) setSelectedItem(null);
    }

    const loadTableData = () => {
        dispatch(loadData(selectedFilters, id));
        dispatch(getFilters(id));
    }
    useEffect(() => {
        dispatch(loadCountries(id));
        loadTableData();
    }, []);

    useEffect(() => {
        if (errorMessage) {
            toast.error(errorMessage, {
                position: 'top-center',
                className: 'cutoff-popup',
                duration: ERROR_TOAST_DUSATION
            });

            const errorTimeout = setTimeout(() => dispatch(setError('')), ERROR_TOAST_DUSATION)
            return () => clearTimeout(errorTimeout)
        }
    }, [errorMessage])


    const setDropDownValues = (selection:ICountry | IInputSugestion | null, field:keyof ISelectedFilters) => {
        const newFilters = {
            ...selectedFilters,
            [field]: selection
        }
        setSelectedFilters(newFilters);
        dispatch(loadData(newFilters, id))
    }

    const handleExportButton = () => {
        dispatch(exportData())
    }

    const handleEdit = (ikaMap:IIKAMap | null) => {
        handleAddEditDialogueBox();
        setSelectedItem(ikaMap);
    }

    const handleDelete = (comment: string) => {
        handleDeleteDialogueBox();
        dispatch(deleteItems(
            comment,
            data.filter(({checked}) => checked).map(({id}) => id),
            id,
            selectedFilters
        ));
    }

    const uploadImportData = async (data:any) => {
        const response = await massUpload(data, id);
        return response;
    }

    const handleOnChange = (e:any) => {
        Papa.parse(e.target.files[0], {
            skipEmptyLines: true,
            header: true,
            complete: (results) => {
                toast.promise(uploadImportData(results.data), {
                    loading: "Loading. wait a moment!",
                    success: (response) => {
                        if (response.error) {
                            console.log("error in IKA Mapping API", response.results.message);
                            dispatch(setError(response.results.message));
                            dispatch({ type: SET_IKA_MAP_DATA_LOADING, payload: false });
                            return 'Something went wrong.'
                        } else {
                            dispatch(loadData(constants.INITIAL_FILTERS, id));
                            return 'Data added successfully.'
                        }
                    },
                    error: 'Something went wrong.',
                },
                    {
                        position: 'top-center',
                        className: 'toast-popup',
                    });
            }
        })
        setTimeout(() => {
            e.target.value = ''
        }, 1500)

    }

    return (
        <Suspense fallback={<div>An error occured!</div>}>
            <div className="user-view-container">
                <div className="brand-category-header-container row">
                    <div className="col-8 brand-category-filter-container">
                        <div className="brand-category-dropdown-container">
                            <label
                                className="pb-1"
                                style={{ paddingLeft: "5px", fontSize: "small" }}
                            >
                                {constants.country_label}
                            </label>
                            <Autocomplete
                                sx={AutocompleteSX}
                                id="selected_country"
                                autoHighlight
                                onChange={(event, newValue) => {
                                    setDropDownValues(newValue, 'selected_country')
                                }}
                                value={selectedFilters.selected_country}
                                options={countries}
                                getOptionLabel={(option:ICountry) => option.title}
                                renderInput={(params) => <TextField {...params} />}
                            />
                        </div>

                        <div className="brand-category-dropdown-container">
                            <label
                                className="pb-1"
                                style={{ paddingLeft: "5px", fontSize: "small", textOverflow: "ellipsis", whiteSpace: 'nowrap' }}
                            >
                                {constants.cust_planning_level_label}
                            </label>
                            <Autocomplete
                                sx={AutocompleteSX}
                                id="cust_planning_level"
                                autoHighlight
                                onChange={(event, newValue) => {
                                    setDropDownValues(newValue, 'cust_planning_level')
                                }}
                                value={selectedFilters.cust_planning_level}
                                getOptionLabel={(option:IInputSugestion) => option.title}
                                options={filters.cust_planning_level}
                                renderInput={(params) => <TextField {...params} />}
                            />
                        </div>
                        <div className="brand-category-dropdown-container">
                            <label
                                className="pb-1"
                                style={{ paddingLeft: "5px", fontSize: "small", textOverflow: "ellipsis", whiteSpace: 'nowrap' }}
                            >
                                {constants.cust_planning_level_name_label}
                            </label>
                            <Autocomplete
                                sx={AutocompleteSX}
                                id="cust_planning_level_name"
                                autoHighlight
                                onChange={(event, newValue) => {
                                    setDropDownValues(newValue, 'cust_planning_level_name')
                                }}
                                value={selectedFilters.cust_planning_level_name}
                                getOptionLabel={(option:IInputSugestion) => option.title}
                                options={filters.cust_planning_level_name}
                                renderInput={(params) => <TextField {...params} />}
                            />
                        </div>
                        <div className="brand-category-dropdown-container">
                            <label
                                className="pb-1"
                                style={{ paddingLeft: "5px", fontSize: "small", textOverflow: "ellipsis", whiteSpace: 'nowrap' }}
                            >
                                {constants.gkc_label}
                            </label>
                            <Autocomplete
                                sx={AutocompleteSX}
                                id="gkc"
                                autoHighlight
                                onChange={(event, newValue) => {
                                    setDropDownValues(newValue, 'gkc')
                                }}
                                value={selectedFilters.gkc}
                                getOptionLabel={(option:IInputSugestion) => option.title}
                                options={filters.gkc}
                                renderInput={(params) => <TextField {...params} />}
                            />
                        </div>
                        <div className="brand-category-dropdown-container">
                            <label
                                className="pb-1"
                                style={{ paddingLeft: "5px", fontSize: "small", textOverflow: "ellipsis", whiteSpace: 'nowrap' }}
                            >
                                {constants.buyng_group_cust_name_label}
                            </label>
                            <Autocomplete
                                sx={AutocompleteSX}
                                id="buyng_group_cust_name"
                                autoHighlight
                                onChange={(event, newValue) => {
                                    setDropDownValues(newValue, 'buyng_group_cust_name')
                                }}
                                value={selectedFilters.buyng_group_cust_name}
                                getOptionLabel={(option:IInputSugestion) => option.title}
                                options={filters.buyng_group_cust_name}
                                renderInput={(params) => <TextField {...params} />}
                            />
                        </div>
                    </div>
                    {adminIds.includes(id) ?
                        (<div className="col-4 brand-category-add-delete-export-button-container">
                            <div style={{ margin: "2rem 0rem 0rem 0rem", fontSize: ".75rem" }}>
                                <input
                                    type={"file"}
                                    id={"csvFileInput"}
                                    accept={".csv"}
                                    onChange={handleOnChange}
                                />
                            </div>
                            <button
                                className="brand-category-export-button mt-3 col"
                                type="button"
                                value="Export Data"
                                onClick={handleExportButton}
                            >
                                Export
                            </button>
    
                            {data.filter(({checked}) => checked).length === 0
                                ? (
                                    <button
                                        className="brand-category-button mt-3 col"
                                        type="button"
                                        value="+ Add New"
                                        onClick={() => handleEdit(null)}
                                    >
                                        <FontAwesomeIcon icon={faPlus} className="search-icon" size="1x" /> Add New
                                    </button>
                                ) : (
                                    <button
                                        className="brand-category-button mt-3 col"
                                        type="button"
                                        value="Delete"
                                        onClick={handleDeleteDialogueBox}
                                    >
                                        <FontAwesomeIcon icon={faTrash} className="search-icon" size="1x" /> Delete
                                    </button>
                                )}
                        </div>) : ""}
                </div>

                <div className="brand-category-body">
                    <div className='other-mfa-table-holder'>
                        <div className='channel-category-chips-container'>
                            {/* CSS Purpose */}
                        </div>
                        {dataLoading ? <div className="table-data-note"><Spinner animation="border" />
                            <p></p>
                        </div> : ""}
                        <IKAMapTable
                            adminIds={adminIds}
                            columns={constants.IKA_MAP_COLUMNS}
                            formId={id}
                            handleEdit={handleEdit}
                        />
                    </div>
                </div>

                <EditModal
                    selectedItem={selectedItem}
                    open={openAddEditDialogueBox}
                    toggleOpen={handleAddEditDialogueBox}
                />
                
                <ChannelCategoryDialogueBox
                    openDialogueBox={openDeleteDialogueBox}
                    handleDeleteDialogueBox={handleDeleteDialogueBox}
                    messageType="Delete"
                    message="Are you sure you want to delete this Map"
                    handleDelete={handleDelete}
                />
            </div>

            <Toaster />
        </Suspense>
    );
}